import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { CheckCircle, XCircle } from 'lucide-react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

export function ApplicationSuccessPage() {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const action = searchParams.get('action') as 'accept' | 'reject' | null;

  console.log('[ApplicationSuccessPage] Rendering with:', { id, action });

  const isAccepted = action === 'accept';

  const handleBackToList = () => {
    console.log('[ApplicationSuccessPage] Navigating back to applications list');
    navigate('/applications');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <Card className="max-w-2xl w-full">
        <CardContent className="text-center py-12">
          <div className="mb-6">
            {isAccepted ? (
              <CheckCircle className="w-16 h-16 text-emerald-500 mx-auto" />
            ) : (
              <XCircle className="w-16 h-16 text-rose-500 mx-auto" />
            )}
          </div>

          <h1 className="text-3xl font-bold mb-4">{isAccepted ? 'Dossier accepté' : 'Dossier refusé'}</h1>

          <p className="text-gray-600 mb-8 max-w-lg mx-auto">
            {isAccepted
              ? 'Le dossier a été accepté avec succès. Un email de confirmation a été envoyé au client. Le dossier passe maintenant en attente de paiement.'
              : 'Le dossier a été refusé. Un email avec la raison du refus a été envoyé au client.'}
          </p>

          <Button onClick={handleBackToList} size="lg">
            Retour à la liste des dossiers
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
